import { Component, OnInit, Pipe, PipeTransform, OnChanges, Input, SimpleChanges, SimpleChange, AfterViewInit, HostListener, ChangeDetectorRef, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ViewChild, ElementRef } from '@angular/core';
import { trigger, state, animate, transition, style } from '@angular/animations';
import { FilterArrayPipe } from '../filter.pipe';
import * as _ from "lodash";
import { BookdetailsComponent } from '../popups/bookdetails/bookdetails.component';
import { Sort } from '@angular/material';
import { BooksFilterComponent } from '../popups/booksFilter/booksFilter.component';
import { bookCategoeyEnums, bookCategories } from '../../shared/models/shelfEnums';
import { Constants } from '../../shared/models/constants';
import { CreatedBookInfoComponent } from '../popups/createdBookInfo/createdBookInfo.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Shelf } from '../../shared/models/shelf';
import { ShelfPouchDb } from '../shelf.pouchdb.service';
import { Component_interactionService } from '../../component_interaction.service';
import { IS_ElectronService } from '../../shared/IS_Electron.service';
import { ExportService } from '../../bookShared/popups/export/exoprt.service';

interface Ipopupconfig {
  height: number,
  width: number,
  direction: string,
  arrowPos: number,
  showPopup: boolean,
  loadDirective: any,
  isBooksFilter: string,
  curComp: any
}

@Component({
  selector: 'app-bookshelf',
  templateUrl: './bookshelf.component.html',
  styleUrls: ['./bookshelf.component.css']
})


export class BookshelfComponent implements OnChanges {
  updatedArrayAfterSort: any[];
  newbook: any;
  // @Input() booksData: any;
  booksData = {
    'bookList': [
      // 'title': '1',

    ],
    'name': '',

  };
  @Input() data: any;
  @ViewChild('bookTitle')
  private elTitle: ElementRef;
  @ViewChild('repeatingBookTypes') repeatingBookTypes: ElementRef;
  @ViewChild('OtherBookTypeRowParent') parentEle: ElementRef;
  availableViewableWidth = 20;
  totalScrollbarWidth;
  counter = Array;
  Math;

  @HostListener('window:resize') onResize() {
    this.updateScrollNavbars();
  }
  // public name;
  sortedData;
  public title;
  public showOverlayDivPdf = false;
  public pdfObj = {};
  public pdfPage;
  public sliderWidth;
  public ebeLength = 0;
  public elessonLength = 0;
  public viewContainer2: string = "grid";
  public purchasesViewType: string = "grid";
  public hideArrowButtons: boolean = false;
  public bookTypes = [];
  public subType = [];
  public hideArrowButtonsEBE: boolean = false;
  public hideArrowButtonsELE: boolean = false;
  SelectedSubType;
  public currentHoverEle;
  public showGridView = false;
  public showAllGridView = true;
  public selectedGridIndex = undefined;
  public gridToggleIcon = 'icon-BottomButton';
  public booksList: any;
  filterBooksArr = [];
  bookCategoeyEnumTypes: any;
  bookCategoryTypes: any;
  subTypes = [];
  reloadBooklist = true;
  bookIdsArrayAfterSort = [];
  public prevStateArr;
  bookTemplates: any;
  templates;
  popupParams: Ipopupconfig = {
    height: 400,
    width: 300,
    direction: "left",
    arrowPos: 50,
    showPopup: false,
    curComp: this,
    loadDirective: '<app-tests></app-tests>',
    isBooksFilter: "books"
  };
  globalPopupPara = <any>{};
  loadBooksView = false;
  bookInfoShelfId;
  indexReturn: any;


  draggedBook;
  draggedBookFrom;
  draggedBookFromId;
  droppedBookAt;
  droppedOnBook;
  lastCreatedShelf;
  myTemplatesArr;
  selectedShelf;
  subscription;
  allFiltersList = [];
  shelfDataSubscription;
  filterUpdatingState = true;
  avoidingFastSwitching = true;
  closeGlobalExportSubscription: any;
  public purchasesInd;
  public purchasesBooks = [];

  showGlobalpopup(popupParams, ev, width, height): void {
    if (height) {
      popupParams.height = height;
    }
    if (width) {
      popupParams.width = width;
    }

    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
  }
  constructor(private exportService: ExportService, private ele: ElementRef, private cdr: ChangeDetectorRef, public dialog: MatDialog, public pouchservice: ShelfPouchDb, private Component_interactionService: Component_interactionService, private ElectronService: IS_ElectronService) {
    this.Math = Math;
  }

  ngOnInit() {
    this.bookCategoeyEnumTypes = bookCategoeyEnums;
    this.bookCategoryTypes = bookCategories;
    if (!this.ElectronService.IS_ELECTRON) {
      this.bookTemplates = Constants.getBookTemplatesArr();
      this.templates = Constants.getTemplates();
    }
    else {
      this.bookTemplates = Constants.getElectronBookTemplatesArr();
      this.templates = Constants.getElectronTemplates();
    }
    var myCompThis = parent.window.document['mycompthis'];
    this.myTemplatesArr = myCompThis.cteatedMytemplates;
    if (this.data.pouchData) {
      this.updatingBookShelfData();
    }




    if (localStorage.allGridview != 'undefined' && localStorage.allGridview != undefined) {
      this.purchasesViewType = localStorage.allGridview;
    }

    var self = this;
    this.subscription = this.Component_interactionService.cast1.subscribe(data => {
      if (data.length != 0 && data.name != 'AllComponent') {
        self.data.pouchData = data;
        self.updatingBookShelfData();
      }
    });

    this.shelfDataSubscription = this.pouchservice.interaction.subscribe(data => {
      if (self.lastCreatedShelf) {
        self.updateListOfShlefs(data);
      }
    })

    this.closeGlobalExportSubscription = this.exportService.closeGlobalExport$.subscribe(data => {

      if (data == "close") {

        self.showExportPopup = false;
      }

    })

  }


  updatingBookShelfData() {

    var self = this;

    this.loadBooksView = true;
    this.booksData.bookList = [];
    this.booksData.bookList = this.data.pouchData.data;
    this.booksData.name = this.data.pouchData.type;
    this.selectedShelf = this.data.pouchData.shelf
    let temp: any;
    temp = _.map(this.booksData.bookList, 'bookType');
    var subtypesArray = [];
    for (let i = 0; i < temp.length; i++) {
      subtypesArray.push(this.bookCategoryTypes[this.bookCategoeyEnumTypes[temp[i]]]);
    }
    this.subTypes = _.uniq(subtypesArray);


    this.prepareNewArray()


    //for test purpose
    debugger;

    if (self.booksData.name == "Purchases") {

      this.purchasesBooks = self.booksData.bookList;

      let downloadingBooksCallback = setInterval(function () {

        if (self.ElectronService.downloadingBooksArray.length) {
          // console.log('downloadingBooksCallback running');
          self.purchasesBooks = self.booksData.bookList;
          if (self.purchasesBooks.length) {
            for (let i = 0; i < self.purchasesBooks.length; i = i + 1) {
              // debugger;
              for (let j = 0; j < self.ElectronService.downloadingBooksArray.length; j = j + 1) {
                // debugger;
                if (self.purchasesBooks[i].bId == self.ElectronService.downloadingBooksArray[j].publishId) {
                  // debugger;
                  // console.log('downloadingBooksCallback condition true');
                  // console.log(self.purchasesBooks[i].bId);
                  self.purchasesBooks[i].isDownloading = true;
                }
              }

            }
          }

        }
        else {
          // console.log('downloadingBooksCallback cleared');
          if (self.purchasesBooks.length) {
            for (let i = 0; i < self.purchasesBooks.length; i = i + 1) {
              // debugger;
              self.purchasesBooks[i].isDownloading = false;
            }
          }
          clearInterval(downloadingBooksCallback);
        }

      }, 500);

    }


    //


  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.shelfDataSubscription) {
      this.shelfDataSubscription.unsubscribe();
    }
    if (this.closeGlobalExportSubscription) this.closeGlobalExportSubscription.unsubscribe();

  }
  ngAfterViewInit() {
    // this.availableViewableWidth = Number(localStorage.availableViewableWidth);

  }
  ngAfterViewChecked() {
    // var parentEle = this.ele.nativeElement.querySelector('.OtherBookTypeRowParent');
    if (this.ele.nativeElement.querySelector('.OtherBookTypeRowParent')) {
      this.availableViewableWidth = this.ele.nativeElement.querySelector('.OtherBookTypeRowParent').offsetWidth - 15;  // 15 is offset
      this.totalScrollbarWidth = this.ele.nativeElement.querySelector('.OtherBookTypeRowParent').scrollLeft;
      localStorage.availableViewableWidth = this.availableViewableWidth;
    }

   
  }
  ngOnChanges(changes: SimpleChanges) {
    this.updateScrollNavbars();
  }


  toggle(): void {
    if (this.purchasesViewType == "grid") {
      this.purchasesViewType = "list";
      localStorage.allGridview = "list"
      this.prevStateArr = JSON.parse(JSON.stringify(this.booksData.bookList))

    } else if (this.purchasesViewType == "list") {
      this.purchasesViewType = "grid";
      localStorage.allGridview = "grid"
    }
  }

  @ViewChild('panel', { read: ElementRef }) public panel: ElementRef;
  @ViewChild('panelEBE', { read: ElementRef }) public panelEBE: ElementRef;
  @ViewChild('panelELE', { read: ElementRef }) public panelELE: ElementRef;

  public onPrevious(type: string): void {

    let dis;
    let temp;
    dis = this.currentHoverEle.querySelector('.booksParent').scrollLeft;
    temp = this.currentHoverEle.querySelector('.booksParent').scrollLeft - this.availableViewableWidth;

    

    // let scrollNavigation = this.currentHoverEle.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }
    var prevEleParent = this.currentHoverEle.closest('.ebeRowParent');
    var prevEleClassList = prevEleParent.querySelector('.prevBooksIcon').classList;
    if(temp <= 0){
      prevEleClassList.add('hidePrevBooksIcon')
    }
    // if (scrollNavigation[activeIndex - 1]) {
    //   scrollNavigation[activeIndex].classList.remove('activeScrollBar');
    //   scrollNavigation[activeIndex - 1].classList.add('activeScrollBar');
    //   if ((activeIndex - 1) == 0) {
    //     prevEleClassList.add('hidePrevBooksIcon')
    //   }
    // }
    // // else {
    //   scrollNavigation[activeIndex].classList.remove('activeScrollBar');
    //   scrollNavigation[0].classList.add('activeScrollBar');
    //   this.currentHoverEle.querySelector('.booksParent').scrollLeft = 0;
    //   return;
    // // }


    if (!this.ElectronService.IS_ELECTRON)
    this.currentHoverEle.querySelector('.booksParent').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
  else
    this.currentHoverEle.querySelector('.booksParent').scrollLeft = temp;


    // var interval = setInterval(() => {
    //   this.currentHoverEle.querySelector('.booksParent').scrollLeft = dis;
    //   dis = dis - 50;
    //   if (dis < temp) {
    //     clearInterval(interval);
    //   }
    // }, 25);
  }

  public onNext(type: string): void {
    let dis;
    let temp;
    dis = this.currentHoverEle.querySelector('.booksParent').scrollLeft;
    temp = this.currentHoverEle.querySelector('.booksParent').scrollLeft + this.availableViewableWidth;

    // let scrollNavigation = this.currentHoverEle.querySelectorAll('.booksNavigation');
    // let activeIndex;
    // for (let i = 0; i < scrollNavigation.length; i++) {
    //   if (scrollNavigation[i].classList.contains('activeScrollBar')) {
    //     activeIndex = i;
    //   }
    // }

    var prevEleParent = this.currentHoverEle.closest('.ebeRowParent');
    var prevEleClassList = prevEleParent.querySelector('.prevBooksIcon').classList;
    // if (scrollNavigation[activeIndex + 1]) {
    //   scrollNavigation[activeIndex].classList.remove('activeScrollBar');
    //   scrollNavigation[activeIndex + 1].classList.add('activeScrollBar');
    //   prevEleClassList.remove('hidePrevBooksIcon');
    // }

    // else {
    //   // scrollNavigation[activeIndex].classList.remove('activeScrollBar');
    //   // scrollNavigation[0].classList.add('activeScrollBar');
    //   this.currentHoverEle.querySelector('.booksParent').scrollLeft = 0;
    //   prevEleClassList.add('hidePrevBooksIcon');
    //   return;
    // }

    // var interval = setInterval(() => {
    //   this.currentHoverEle.querySelector('.booksParent').scrollLeft = dis;
    //   dis = dis + 100;
    //   if (dis > temp) {
    //     this.currentHoverEle.querySelector('.booksParent').scrollLeft = temp;
    //     clearInterval(interval);
    //   }
    // }, 25);
    let maxScrollLeftOfEle = this.currentHoverEle.querySelector('.booksParent').scrollWidth - this.currentHoverEle.querySelector('.booksParent').clientWidth;

    if(maxScrollLeftOfEle > this.currentHoverEle.querySelector('.booksParent').scrollLeft){
      prevEleClassList.remove('hidePrevBooksIcon');
      if (!this.ElectronService.IS_ELECTRON)
      this.currentHoverEle.querySelector('.booksParent').scrollTo({ left: temp, top: 0, behavior: 'smooth' });
    else
      this.currentHoverEle.querySelector('.booksParent').scrollLeft = temp;
    }else{
      prevEleClassList.add('hidePrevBooksIcon');
      if (!this.ElectronService.IS_ELECTRON)
      this.currentHoverEle.querySelector('.booksParent').scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    else
      this.currentHoverEle.querySelector('.booksParent').scrollLeft = 0;
    }

   

  }
  mouseEnter(type: string, event, index) {
    this.currentHoverEle = event.target;
    if (type == "recent") {
      if (this.panel.nativeElement.scrollWidth > this.panel.nativeElement.offsetWidth) {
        this.hideArrowButtons = true;
      }
    }
    else {
      if (this.currentHoverEle.querySelector('.booksParent').scrollWidth > this.currentHoverEle.querySelector('.booksParent').offsetWidth) {
        this.SelectedSubType = index;
      }
    }

  }

  mouseLeave(type: string, event) {
    if (type == "recent") {
      this.hideArrowButtons = false;
    }
    else if (type == "EBE") {
      this.SelectedSubType = undefined;
    }
    else if (type == "ELE") {
      this.SelectedSubType = undefined;
    }
  }


  toggleLeftSidenav() {
    // this.myApp.toggleLeftPanel();
    // this.myApp.isLeftnavbarShow = !this.myApp.isLeftnavbarShow;
  }

  updateFilter(ind, Arr) {
    this.filterBooksArr = Arr;
    this.filterUpdatingState = true;
    if (this.allFiltersList.length == Arr.length) {
      this.filterBooksArr = [];
      Arr = [];
      this.filterUpdatingState = true;
      this.showAllGridView = true;
      this.gridToggleIcon = 'icon-BottomButton';
      this.selectedGridIndex = undefined;
      return;
    }

    if (Arr.length == 1) {
      let index = _.findIndex(this.subTypes, function (o) { return o == Arr[0]; });
      this.selectedGridIndex = undefined
      this.displayGridViewForBooks(index, Arr[0]);
      this.selectedGridIndex = index;
    } else if (!Arr.length) {
      // this.showAllGridView = true;
      // this.gridToggleIcon = 'icon-BottomButton';
      this.selectedGridIndex = undefined;
      this.filterBooksArr = [];
      this.filterUpdatingState = false
    } else {
      this.showAllGridView = false;
      this.gridToggleIcon = 'icon-BottomButton';
      this.selectedGridIndex = undefined;
    }
  }

  isSelectedGridIndAvl(name) {
    let index = _.findIndex(this.filterBooksArr, function (o) { return o == name; });
    if (index != -1) {
      return true;
    } else {
      return false;
    }
  }


  displayPdfOverLay(bookObj) {
    this.SelectedSubType = undefined;
    this.pdfObj = bookObj;
    this.Component_interactionService.selectedBookData(bookObj);
    // this.data.this.onBookClick(bookObj);
    this.sliderWidth = 744;
    this.pdfPage = 0;
  }

  updateSlide(num) {
    this.pdfPage = num;
  }

  makeBookFav(obj, state) {

    var self = this;
    if (!this.avoidingFastSwitching) {
      return;
    } else {
      this.avoidingFastSwitching = false;
      setTimeout(function () {
        self.avoidingFastSwitching = true;
      }, 1000);
    }

    obj.isFav = !obj.isFav;
    this.pouchservice.updateFavBook(obj)
  }




  toggleRecentGridView() {
    if (this.showGridView) {
      this.gridToggleIcon = 'icon-BottomButton';
    } else {
      this.gridToggleIcon = 'icon-TopButton';
    }

    this.showGridView = !this.showGridView;
  }

  displayGridViewForBooks(index, type) {
    this.SelectedSubType = undefined;
    this.filterBooksArr = [];
    this.filterBooksArr.push(type);

    if (this.selectedGridIndex == index) {
      this.filterBooksArr = [];
      this.showAllGridView = true;
      this.selectedGridIndex = undefined;
      this.gridToggleIcon = 'icon-BottomButton';
    } else {
      this.showAllGridView = false;
      this.selectedGridIndex = index;
      this.gridToggleIcon = 'icon-TopButton';
    }
  }


  displayFilteredBooks(type) {
    if (this.filterBooksArr.length == 0) {
      return true;
    }
    else {
      let ind = _.findIndex(this.filterBooksArr, function (o) { return o == type; });
      if (ind != -1) {
        return true;
      } else {
        return false;
      }

    }
  }

  onPdfObjChanged(ev) {
    this.showOverlayDivPdf = false
  }


  updateNextIcon(count, ind) {
    if (this.repeatingBookTypes) {
      let a = this.repeatingBookTypes.nativeElement.querySelectorAll('.ebeRowParent');
      let gridIcon = this.repeatingBookTypes.nativeElement.querySelectorAll('.gridViewIconForBooks');

      if(!a[ind]){
        return
      }

      var classList = a[ind].querySelector('.nextBooksIcon').classList;
      var gridIconClassList = gridIcon[ind].classList;
      if ((170 * count) > this.availableViewableWidth) {
        classList.remove('hidePrevBooksIcon');
        gridIconClassList.remove('hidePrevBooksIcon');
      } else {
        classList.add('hidePrevBooksIcon');
        gridIconClassList.add('hidePrevBooksIcon');
      }
    }
  }


  updateScrollNavbars() {
    if (this.parentEle) {
      this.availableViewableWidth = this.parentEle.nativeElement.offsetWidth - 15;
    }
    else {
      this.availableViewableWidth = Number(localStorage.availableViewableWidth)
    }

    if (this.availableViewableWidth < 0) {
      this.availableViewableWidth = Number(localStorage.availableViewableWidth)
    }



    if (this.repeatingBookTypes) {
      let parentsOfBooks = this.repeatingBookTypes.nativeElement.querySelectorAll('.ebeRowParent')
      for (var i = 0; i < parentsOfBooks.length; i++) {
        var scrollNavigation = parentsOfBooks[i].querySelectorAll('.booksNavigation');
        for (var j = 0; j < scrollNavigation.length; j++) {
          scrollNavigation[j].classList.remove('activeScrollBar');
          scrollNavigation[0].classList.add('activeScrollBar');
        }
        parentsOfBooks[i].querySelector('.booksParent').scrollLeft = 0;
      }
    }

    var prevIconEles = this.ele.nativeElement.querySelectorAll('.prevBooksIcon');
    for (var i = 0; i < prevIconEles.length; i++) {
      prevIconEles[i].classList.add('hidePrevBooksIcon');
    }
  }

  selBookDetals;
  showBookDetails(popupParams: any, ev, width, height, book, ShelfName): void {


    if (book.bookCategory == 1) {
      popupParams.loadDirective = CreatedBookInfoComponent;
    }
    else {
      popupParams.loadDirective = BookdetailsComponent;
    }

    // popupParams.loadDirective = BookdetailsComponent;
    popupParams.state = 'bookshelf';

    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
    popupParams.height = height;
    popupParams.width = width;
    popupParams.arrowPos = 150;
    popupParams.direction = "left";
    if (ev.clientX > window.innerWidth * 0.6) {
      popupParams.direction = "right";
    }
    popupParams.bookDetals = true;
    this.selBookDetals = book;
    this.bookInfoShelfId = this.selectedShelf._id;
  }

  prepareNewArray() {

    this.newbook = []
    for (var i = 0; i < this.subTypes.length; i++) {

      this.newbook[i] = [];
      for (var j = 0; j < this.booksData.bookList.length; j++) {
        if (this.bookCategoryTypes[bookCategoeyEnums[this.booksData.bookList[j].bookType]] == this.subTypes[i]) {
          this.newbook[i].push(this.booksData.bookList[j])
        }

      }
    }
    this.prevStateArr = JSON.parse(JSON.stringify(this.newbook));
  }


  sortData(sort: Sort, ind: number, order) {


    const data = this.newbook[ind].slice();

    // const data = this.booksData.bookList;

    if (!sort.active || sort.direction == '') {


      this.newbook[ind] = this.prevStateArr[ind];
      this.updatedDataAfterSort(ind);
      return;

    }

    this.sortedData = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'title': return this.compare(a.title, b.title, isAsc);
        // bookCategoryTypes[bookCategoeyEnums[puchases.bookType]]
        case 'type': return this.compare((this.bookCategoryTypes[bookCategoeyEnums[a.bookType]]).trim(), (this.bookCategoryTypes[bookCategoeyEnums[b.bookType]]).trim(), isAsc);

        case 'last seen': return this.compare(a.lastSeenDate, b.lastSeenDate, isAsc);

        case 'author': return this.compare(a.author, b.author, isAsc);
        default: return 0;

      }

    });
    this.newbook[ind] = this.sortedData

    return this.updatedDataAfterSort(ind);

  }


  compare(a, b, isAsc) {

    if (a == b) {

    }
    else {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

  }



  updatedDataAfterSort(ind) {

    this.bookIdsArrayAfterSort = []
    this.updatedArrayAfterSort = []
    for (var i = 0; i < this.newbook.length; i++) {
      for (var j = 0; j < this.newbook[i].length; j++) {
        this.bookIdsArrayAfterSort.push(this.newbook[i][j]._id)
      }

    }




    // this.ShelfPouchDb.updateAllShelfsArray(this.bookIdsArrayAfterSort,this.booksData.name,this)
  }



  applyFilterforBooks(popupParams: any, ev, width, height): void {

    if (!this.subTypes.length) {
      return;
    }

    popupParams.loadDirective = BooksFilterComponent;
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
    popupParams.height = height;
    popupParams.width = width;
    popupParams.filterList = this.subTypes;
    popupParams.arrowPos = 170;
    popupParams.direction = "top";
    this.allFiltersList = this.subTypes;
  }

  deleteBookFromArray(data) {


    var self = this;
    var index = _.findIndex(this.booksData.bookList, function (o) {

      self.indexReturn = o;
      return self.indexReturn._id == data._id;
    });

    this.booksData.bookList.splice(index, 1);

    this.reloadBooklist = false;
    this.globalPopupPara.showPopup = false;

    setTimeout(() => {
      this.reloadBooklist = true;
    }, 10);

  }

  assignDragData(book, folderName, id) {
    if (folderName == 'Favourites') {
      return;
    }

    let temp = {
      book: book,
      draggingFrom: folderName,
      draggingFromId: id
    }
    return temp;
  }


  onItemDrop(ev, obj, droppedAt) {

    if (!ev.dragData.book) {
      return;
    }

    var temp = _.isEqual(obj, ev.dragData.book);
    if (temp) {
      return;
    }

    this.draggedBook = ev.dragData.book;
    this.draggedBookFrom = ev.dragData.draggingFrom;
    this.draggedBookFromId = ev.dragData.draggingFromId
    this.droppedBookAt = droppedAt;
    this.droppedOnBook = obj;
    // this.draggingFrom = ev.dragData.draggingFrom;

    var myCompThis = parent.window.document['mycompthis'];
    let information = { 'name': 'New Shelf', data: myCompThis.myContentElements, state: 'creatingFolder' }
    let dialogRef = this.dialog.open(createFolderBookshelf, {
      width: '315px',
      data: information,
      disableClose: false
    });

    var self = this;

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        self.addingNewFolder(result);
      }
    });

  }

  addingNewFolder(name) {
    var self = this;
    var timestamp = Math.round(new Date().getTime() / 1000);
    var id = Constants.USER + "." + timestamp + ".shelf";
    var shelfObj = new Shelf();
    shelfObj.bookIds = [];
    shelfObj.createdAt = timestamp;
    shelfObj.owner = Constants.USER;
    shelfObj.title = name;
    shelfObj.shelfType = "created";
    shelfObj._id = id;
    this.lastCreatedShelf = shelfObj;

    var ind = parent.window.document['mycompthis'].selectedTabList;
    if (ind == undefined) {
      ind = 0;
    }
    else {
      ind = ind + 1
    }

    this.pouchservice.createShelf(shelfObj).then(function (res) {
      self.pouchservice.alternateGetShelfData(ind);
    })
  }

  updateListOfShlefs(docs) {

    var self = this;
    let ev = {
      book: this.draggedBook,
      draggingFrom: this.draggedBookFrom,
      draggingFromId: this.draggedBookFromId
    }
    let ev1 = {
      book: self.droppedOnBook,
      draggingFrom: self.droppedBookAt,
      draggingFromId: this.draggedBookFromId
    }

    this.pouchservice.dragAndDropBookOnOtherBook(ev, self.lastCreatedShelf, false).then(function (res) {
      if (!res) {
        self.pouchservice.dragAndDropBookOnOtherBook(ev1, self.lastCreatedShelf, true).then(function (res) {
          self.lastCreatedShelf = undefined;
        })
      }
    })

  }

  addMyTemplateCoverPage(book) {
    var myCompThis = parent.window.document['mycompthis'];
    this.myTemplatesArr = myCompThis.cteatedMytemplates;

    var index = _.findIndex(this.myTemplatesArr, function (o: any) { return o._id == book.templateId; });
    if (index > -1) {
      return this.myTemplatesArr[index].cover.thumbUrl;
    }
  }

  getReadedAreaWidth(book) {
    return (Number(book.lastOpenedPage) / book.pageCount) * 100 + '%';
  }


  public exportGlobalData: any;
  showExportInnerPopup = false;
  showExportPopup = false;
  manageExportPopup(data) {

    var obj = {
      'popupProps': {
        'bookDataObj': {},
        'bookObj': data,
        'pageCount': 1,
        'CE': false
      }
    }
    var self = this;


    if (data.bookCategory == 1) {

      obj.popupProps.CE = true;
    }


    this.pouchservice.getBookDataObjForExport(data).then(function (result) {

      obj.popupProps.bookDataObj = result[0];
      obj.popupProps['isGlobalExport'] = true;

      self.exportGlobalData = obj;

      setTimeout(() => {

        self.showExportInnerPopup = true;
      }, 100);
      self.showExportPopup = true;

    }).catch(function (err) {


    })

  }



  closeExportPopup(event, state) {

    event.stopPropagation();
    if (state == true)
      this.showExportPopup = false;
  }
}


@Component({
  selector: 'app-createFolderBooks',
  templateUrl: '../mycontent/newFolder.popup.html',
  styleUrls: ['../shelf.component.css', '../mycontent/mycontent.component.css']
})
export class createFolderBookshelf {
  newFolderTitle;
  isAvailable;
  showError = false;
  templateAsEnrichmentObj = {
    showPopup: false
  }
  constructor(
    public dialogRef: MatDialogRef<createFolderBookshelf>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  updateNewFolderName(ev, name) {
    if (ev.which == 13) {
      this.onYesClick(name);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(name) {
    this.isAvailable = undefined;

    this.isFolderNameAlreadyExist(this.data.data, name);

    if (this.isAvailable || name == '' || !name) {
      this.showError = true;
      return;
    }

    this.dialogRef.close(name);
  }

  isFolderNameAlreadyExist(data, name) {
    if (name == 'Purchases' || name == 'Creations' || name == 'Imports' || name == 'Favourites' || name == 'Favorites') {
      this.isAvailable = true;
    }
  }


}


// WEBPACK FOOTER //
// ./src/app/shelf/bookshelf/bookshelf.component.ts